import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../../Globals/constants';
import { DropTarget } from 'react-dnd';
import Radium from 'radium';
import { semanticColors } from '../../Globals/styles';

class EmployeeDropable extends Component {
  render() {
    const { connectDropTarget, isOver } = this.props;

    return connectDropTarget(
      <div style={[styles.dropTarget]}>
        {isOver &&
          <div style={styles.isOver}>
          </div>
        }
      </div>
    )
  }
}


var styles = {
  dropTarget: {
    height: '130px',
    position: 'absolute',
    width: '100%',
    top: '0',
    left: '0',
    zIndex: '10'
  },
  isOver: {
    height: '130px',
    backgroundColor: semanticColors.info,
    opacity: '0.5'
  }
}

const employeeTarget = {
  drop(props, monitor) {
    //if component was already dropped - no nothing
    if(monitor.didDrop()) return;
    //if user NOT is already registered on this activity register him
    props.onWorkplaceEmployeeDrop(monitor.getItem().employee);


  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver({ shallow: true })
  };
}
  EmployeeDropable.propTypes = {
    isOver: PropTypes.bool.isRequired,
    workplaceId: PropTypes.string.isRequired,
    isEmployeeAlreadyDropped: PropTypes.func.isRequired,
    onWorkplaceEmployeeDrop: PropTypes.func.isRequired
  };
export default DropTarget(dragNDropConstants.EMPLOYEE, employeeTarget, collect)(Radium(EmployeeDropable));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Kanban/employeeDropable.jsx